/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { Document } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { DocumentDetails } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { DocumentsFilteringRequest } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Display the list of document for the authenticated User
         * @summary Get the documents info for a User
         * @param {string} storeId The store identifier.
         * @param {DocumentsFilteringRequest} [documentsFilteringRequest] The request object for document request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDocuments: async (storeId: string, documentsFilteringRequest?: DocumentsFilteringRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getCustomerDocuments', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/resources/getCustomerDocuments`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentsFilteringRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display the details of document for the authenticated User and Document ID
         * @summary Get the document detail using the document ID
         * @param {string} storeId The store identifier.
         * @param {string} documentId The document identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentByID: async (storeId: string, documentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getDocumentByID', 'storeId', storeId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocumentByID', 'documentId', documentId)
            const localVarPath = `/store/{storeId}/resources/getCustomerDocuments/{documentId}`
                .replace(`{${"storeId"}}`, String(storeId))
                .replace(`{${"documentId"}}`, String(documentId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Display the list of document for the authenticated User
         * @summary Get the documents info for a User
         * @param {string} storeId The store identifier.
         * @param {DocumentsFilteringRequest} [documentsFilteringRequest] The request object for document request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDocuments(storeId: string, documentsFilteringRequest?: DocumentsFilteringRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDocuments(storeId, documentsFilteringRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display the details of document for the authenticated User and Document ID
         * @summary Get the document detail using the document ID
         * @param {string} storeId The store identifier.
         * @param {string} documentId The document identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentByID(storeId: string, documentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentByID(storeId, documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * Display the list of document for the authenticated User
         * @summary Get the documents info for a User
         * @param {string} storeId The store identifier.
         * @param {DocumentsFilteringRequest} [documentsFilteringRequest] The request object for document request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDocuments(storeId: string, documentsFilteringRequest?: DocumentsFilteringRequest, options?: any): AxiosPromise<Document> {
            return localVarFp.getCustomerDocuments(storeId, documentsFilteringRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Display the details of document for the authenticated User and Document ID
         * @summary Get the document detail using the document ID
         * @param {string} storeId The store identifier.
         * @param {string} documentId The document identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentByID(storeId: string, documentId: string, options?: any): AxiosPromise<DocumentDetails> {
            return localVarFp.getDocumentByID(storeId, documentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * Display the list of document for the authenticated User
     * @summary Get the documents info for a User
     * @param {string} storeId The store identifier.
     * @param {DocumentsFilteringRequest} [documentsFilteringRequest] The request object for document request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getCustomerDocuments(storeId: string, documentsFilteringRequest?: DocumentsFilteringRequest, options?: any) {
        return DocumentsApiFp(this.configuration).getCustomerDocuments(storeId, documentsFilteringRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display the details of document for the authenticated User and Document ID
     * @summary Get the document detail using the document ID
     * @param {string} storeId The store identifier.
     * @param {string} documentId The document identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentByID(storeId: string, documentId: string, options?: any) {
        return DocumentsApiFp(this.configuration).getDocumentByID(storeId, documentId, options).then((request) => request(this.axios, this.basePath));
    }
}
